import React from "react";
import { Badge, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { getProjectStepImg, getProjectStepName } from 'utils/projects';

class ProjectWork extends React.Component {

    state = {
        navPill: 1,
        project: {},
        project_logs_clients: [],
    }

    render() {

        const current_step = this.props.project.step;

        return (
            <>

                <Card>
                    <CardBody>
                        <Row>
                            <Col lg={3} className="pr-5">
                                <img src={getProjectStepImg(current_step)} className="w-100 " alt="..." />
                            </Col>
                            <Col lg={9} className="pl-0">
                                <h5>Project Status: {getProjectStepName(current_step)}</h5>
                                <p>
                                    {current_step === 1 && 'This step is where we gather all the information that we need to begin planning or updating a project. This includes things like collecting logos, color schemes, images, and doing research on how to most effectively undergo what\'s coming up. '}
                                    {current_step === 2 && 'Architecture planning is absolutely crucial to do BEFORE any work on a project starts. During this phase we plan out database structure, coding architecture, system fail safes, web hosting, and project / task timelines. '}
                                    {current_step === 3 && 'This is where the magic happens and is our favorite part of any project. Developing the project code base is when the project takes form and begins to function as expected. This is often the longest phase in any project or applicaton update and is why we built the Architeck project management system from the ground up. It allows us to finish this process as effectively as possible while keeping you updated every step of the way. '}
                                    {current_step === 4 && 'A code base that is untested is just a word scramble of numbers and letters,  it\'s essentially useless. During the testing phase we run all unit tests that were written for you project as well as conduct manual testing throughout your application.'}
                                    {current_step === 5 && 'At this point we\'ve made it! Our application is running, tested, and set up to grow along with you. While this may be the point where we hand your application off to you it\'s not where things stop. As time goes on your application will need updates, patches, and maintenance... it is a living breathing animal after all. The fun is just getting started and you can come back here at any time to request updates, report bugs, etc.'}
                                </p>
                            </Col>
                            
                        </Row>
                    </CardBody>
                </Card>

                <Row>
                    
                    {current_step !== 1 && (
                        <Col md={3}>

                            {1 < current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="success" pill>Done</Badge>
                            ) : 0 === current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="info" pill>Next</Badge>
                            ): null}
                            

                            <Card style={styles.card}>
                                <CardHeader>
                                    <h5 className="mb-0">{getProjectStepName(1)}</h5>
                                </CardHeader>
                                <CardBody><img src={getProjectStepImg(1)} className="w-100" alt="..." /></CardBody>
                            </Card>
                        </Col>
                    )}

                    {current_step !== 2 && (
                        <Col md={3}>

                            {2 < current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="success" pill>Done</Badge>
                            ) : 1 === current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="info" pill>Next</Badge>
                            ): null}

                            <Card style={styles.card}>
                                <CardHeader>
                                    <h5 className="mb-0">{getProjectStepName(2)}</h5>
                                </CardHeader>
                                <CardBody><img src={getProjectStepImg(2)} className="w-100" alt="..." /></CardBody>
                            </Card>
                        </Col>
                    )}
                    {current_step !== 3 && (
                        <Col md={3}>

                            {3 < current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="success" pill>Done</Badge>
                            ) : 2 === current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="info" pill>Next</Badge>
                            ): null}

                            <Card style={styles.card}>
                                <CardHeader>
                                    <h5 className="mb-0">{getProjectStepName(3)}</h5>
                                </CardHeader>
                                <CardBody><img src={getProjectStepImg(3)} className="w-100" alt="..." /></CardBody>
                            </Card>
                        </Col>
                    )}
                    {current_step !== 4 && (
                        <Col md={3}>

                            {4 < current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="success" pill>Done</Badge>
                            ) : 3 === current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="info" pill>Next</Badge>
                            ): null}

                            <Card style={styles.card}>
                                <CardHeader>
                                    <h5 className="mb-0">{getProjectStepName(4)}</h5>
                                </CardHeader>
                                <CardBody><img src={getProjectStepImg(4)} className="w-100" alt="..." /></CardBody>
                            </Card>
                        </Col>
                    )}
                    {current_step !== 5 && (
                        <Col md={3}>

                            {5 < current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="success" pill>Done</Badge>
                            ) : 4 === current_step ? (
                                <Badge className="shadow-lg" style={styles.badge} color="info" pill>Next</Badge>
                            ): null}

                            <Card style={styles.card}>
                                <CardHeader>
                                    <h5 className="mb-0">{getProjectStepName(5)}</h5>
                                </CardHeader>
                                <CardBody><img src={getProjectStepImg(5)} className="w-100" alt="..." /></CardBody>
                            </Card>
                        </Col>
                    )}
                    
                </Row>
             
            </>
        );
    }
}

const styles = {

    card: {
        opacity: .7
    },

    badge: {
        position: 'absolute',
        top: '50%',
        left: '40%',
        zIndex: 2,
    }

}

export default ProjectWork

